<template>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 510.61 510.61"
  >
    <path
      d="M255.31,488.22h0c-128.63,0-232.91-104.28-232.91-232.91S126.67,22.4,255.31,22.4h0V0h0C114.3,0,0,114.3,0,255.31s114.3,255.31,255.31,255.31h0v-22.4Z"
      style="fill: #009245"
    />
    <path
      d="M255.31,488.22h0c128.63,0,232.91-104.28,232.91-232.91,0-128.63-104.28-232.91-232.91-232.91h0V0h0c141,0,255.31,114.3,255.31,255.31s-114.3,255.31-255.31,255.31h0v-22.4Z"
      style="fill: #006837"
    />
    <polygon
      points="255.31 262.13 170.56 330.65 117.34 264.84 99.5 279.28 167.15 362.94 255.31 291.65 255.31 262.13"
      style="fill: #009245"
    />
    <polygon
      points="255.31 291.52 411.12 165.52 396.68 147.67 255.31 262 255.31 291.52"
      style="fill: #006837"
    />
  </svg>
</template>
